
  <mat-card class="publication-tile pointer" [routerLink]="sharedService.buildRoute(['news', publication.urlTitle])" [ngClass]="{'publication-widget': widget===true, 'simple': simple===true}">
    <div *ngIf="!widget || publication.mainImage" style="position: relative;flex:1;">
      <img appImgFallback  class="main_image" [ngClass]="{'simple': simple===true}" style=" padding:0;flex: 1;box-shadow: 0px 0px 0px 1px rgba(200, 200, 200, 0.4);" src="{{(publication.mainImage) ? sharedService.getImage(publication.mainImage) : sharedService.getSVG(defaultImagePublication, (entity.primaryColor | removeHexColor))}}">

      <div *ngIf="publication.match && publication.match.id && simple != true" style="width: 100%;margin-top:10px;position:absolute;bottom:0">
        <div class="match pointer" style="max-width: 400px;
        margin: 0 auto;
        margin-right: auto;
        padding:0px;
        left: 0;
        right: 0;
        text-align: center;
        padding:0px 20px
        ">
          <app-match-tile
            [localTeam]="publication.match.localTeam"
            [visitorTeam]="publication.match.visitorTeam"
            [thirdTeam]="publication.match.thirdTeam"
            [localMember]="publication.match.localMember"
            [visitorMember]="publication.match.visitorMember"
            [thirdMember]="publication.match.thirdMember"
            [match]="publication.match"
            [inPublication]="false"
            [widget]="true">
          </app-match-tile>
        </div>
      </div>
    </div>
    <div style="position: absolute;top: 10px;left: 10px;" class="m-b-4" *ngIf="publication.tags && publication.tags.length > 0 && simple != true">
      <span *ngIf="publication.anchor == true"   class="pointer"
      style="background-color:#000;color:#fff;margin-right:10px;padding:4px 6px 4px 6px;border-radius: var(--client-radius);font-size:0.65rem;font-weight: 600;">
      {{'general.anchor' | translate}}
    </span>
      <span *ngFor="let tag of publication.tags; let i = index" [style.background]="tag.color"  class="pointer"
        [routerLink]="sharedService.buildRoute(['news','category', tag.id, tag.name])"
        style="color:#fff;margin-right:10px;padding:4px 6px 4px 6px;border-radius: var(--client-radius);font-size:0.65rem;font-weight: 600;">
        {{ tag.name }}
      </span>
    </div>

    <mat-card-content>
      <mat-card-subtitle [ngClass]="{'simple': simple===true}"><span>{{publication.date | dateFormat:'ll'}}
      </span>
      
    </mat-card-subtitle>
      <mat-card-title [ngClass]="{'simple': simple===true}">
        <span>{{publication.title}}</span>
      
        
        <div *ngIf="publication.body && simple != true" [innerText]="getPlainText(publication.body)" style="font-size: 0.8rem;font-weight: 300;margin-top:10px;    white-space: normal;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        line-height: 1.2em;">
         
        </div>
        
      </mat-card-title>
      
      <div *ngIf="
      publication.poll ||
      publication.matchComponent ||
      publication.form ||
      publication.event ||
      publication.geolocation ||
      (publication.socialExternalUrl && social != null) ||
      (publication.galleryImages && publication.galleryImages.length > 0) ||
      (publication.team && publication.team.teamTemplate && publication.team.teamTemplate.length > 0) ||
      (publication.team && publication.team.teamTemplate && publication.team.teamTemplate.length == 0) ||
      publication.competition && publication.competition.id
      " style="position: absolute; background-color: #fff; border-radius: 100px; top: -20px; right: 16px; display: flex; align-items: center;  padding: 0px">
        <!-- <span *ngIf="publication.poll" class="mat-card-icon" style="float: right;"><mat-icon matTooltip="{{ 'publication.poll' | translate }}" style="height:14px;">equalizer</mat-icon></span>
        <span *ngIf="publication.matchComponent" class="mat-card-icon" style="float: right;"><mat-icon matTooltip="{{ 'menu.matches' | translate }}" style="height:14px;">swap_horiz</mat-icon></span>
        <span *ngIf="publication.form" class="mat-card-icon" style="float: right;"><mat-icon matTooltip="{{ 'publication.form' | translate }}" style="height:14px;">list_alt</mat-icon></span>
        <span *ngIf="publication.event" class="mat-card-icon" style="float: right;"><mat-icon matTooltip="{{ 'publication.event' | translate }}" style="height:14px;">date_range</mat-icon></span>
        <span *ngIf="publication.geolocation" class="mat-card-icon" style="float: right;"><mat-icon matTooltip="{{ 'publication.geolocation' | translate }}" style="height:14px;">place</mat-icon></span>
        <span *ngIf="publication.galleryImages && publication.galleryImages.length > 0" class="mat-card-icon" style="float: right;"><mat-icon matTooltip="{{ 'publication.multimedia' | translate }}" style="height:14px;">image</mat-icon></span> -->


        
        <!-- <ng-container *ngIf="publication.socialExternalUrl && social != null">
          <a class="team"
          matTooltip="{{ social.langKey | translate }}" href="{{publication.socialExternalUrl}}" target="new">
            <mat-icon  class="pointer" style="height:38px;width: 38px;padding:6px" *ngIf="social.icon.includes('svg_')" svgIcon="{{social.icon}}"> </mat-icon>
            <mat-icon  class="pointer" style="height:38px;width: 38px;padding:6px" *ngIf="!social.icon.includes('svg_')"> {{social.icon}}</mat-icon>
          </a>
        </ng-container> -->

        <ng-container *ngIf="publication.team && publication.team.teamTemplate.length > 0">
          <a class="team"
          matTooltip="{{publication.team.name}} | {{typeService.getType(publication.team.categoryId).name}} | {{typeService.getType(publication.team.sportId).name}}" href=""
          [routerLink]="sharedService.buildRoute(['teams', publication.team.id, typeService.getType(publication.team.teamTemplate[0].seasonId).name])">
            <img appImgFallback  [ngClass]="{'simple': simple===true}" src="{{(publication.team.shield) ? sharedService.getImage(publication.team.shield) : sharedService.getImage(defaultShieldTeam)}}">
          </a>
        </ng-container>
        <ng-container *ngIf="publication.team && publication.team.teamTemplate.length == 0">
          <span class="team"
          matTooltip="{{publication.team.name}} | {{typeService.getType(publication.team.categoryId).name}} | {{typeService.getType(publication.team.sportId).name}}" href=""
          >
            <img appImgFallback  [ngClass]="{'simple': simple===true}" src="{{(publication.team.shield) ? sharedService.getImage(publication.team.shield) : sharedService.getImage(defaultShieldTeam)}}">
          </span>
        </ng-container>
        <ng-container *ngIf="publication.competition && publication.competition.id">
          <span class="team"
          matTooltip="{{publication.competition.name}} | {{typeService.getType(publication.competition.categoryId).name}} | {{typeService.getType(publication.competition.sportId).name}}" href=""
          [routerLink]="sharedService.buildRoute(['competitions', publication.competition.id])"
          >
            <img appImgFallback [ngClass]="{'simple': simple===true}" src="{{(publication.competition.icon) ? sharedService.getImage(publication.competition.icon) : sharedService.getImage(defaultShieldCompetition)}}">
          </span>
        </ng-container>
        
      </div>

      <div *ngIf="
      publication.sponsor && publication.sponsor.id
      " style="position: absolute; background-color: #fff; border-radius: var(--client-radius); top: -20px; right: 16px;display: flex; align-items: center;  padding: 0px">


        <ng-container *ngIf="publication.sponsor && publication.sponsor.id">
          <span class="team sponsor"
          matTooltip="{{publication.sponsor.name}}" href=""
          [routerLink]="sharedService.buildRoute(['sponsors', publication.sponsor.id])"
          >
            <img appImgFallback [ngClass]="{'simple': simple===true}" class="sponsor" src="{{(publication.sponsor.image) ? sharedService.getImage(publication.sponsor.image) : sharedService.getImage(defaultShieldCompetition)}}">
          </span>
        </ng-container>
        
      </div>
      
    </mat-card-content>
    <!-- <hr style="width: 100%;margin-top: 0px;margin-bottom: 0px;"> -->
  </mat-card>

